import React from "react";
import './SueBiblio.css'; 

const SueBiblio = () => {

  return (
    <div className="biblioDiv">
  <h2 align="center">
    E. Sue Savage-Rumbaugh
    <br />
    Selected publications
  </h2>
  <p>
    Rumbaugh, D. M., Savage-Rumbaugh, E. S. (1978). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1978-Chimpanzee-Language-Research.pdf"
    >
      Chimpanzee language research: Status and potential.
    </a>
    <em> Behavior Research Methods &amp; Instrumentation, 10(2)</em>, 119-131. 
  </p>
  <p>
    Rumbaugh, D. M., Savage-Rumbaugh, E. S., &amp; Gill, T. V. (1978).  Language
    Skills, Cognition, and the Chimpanzee.  In F. C. C. Peng (Ed.),{" "}
    <em>Sign Language and Language Acquisition in Man and Ape</em>
    (pp. 137-159). Westview Press. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=6ede8ad1-4c2b-3573-bff1-b85c5a692de7"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Rumbaugh, D. M. (1978).  Symbolization,
    language, and chimpanzees: a theoretical reevaluation based on initial
    language acquisition processes in four young <em>Pan troglodytes.</em>
    <em> Brain and Language, 6</em>(3), 265-300. 
    <a className="access" href="https://doi.org/10.1016/0093-934x(78)90063-9">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Rumbaugh, D. M., &amp; Boysen, S. (1978). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1978-Symbolic-Communication-Chimps.pdf"
    >
      Symbolic communication between two chimpanzees (<em>Pan troglodytes</em>).
    </a>
    <em> Science, 201</em>(4356), 641-644. 
    <a className="access" href="https://doi.org/10.1126/science.675251">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1979).  Symbolic Communication: Its Origin and Early
    Development in the Chimpanzee. 
    <em> New Directions for Child Development, 3</em>, 1-15. 
    <a className="access" href="https://doi.org/10.1002/cd.23219790303">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Rumbaugh, D. M., Premack, D., &amp; Woodruff, G.
    (1979). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1979-Chimpanzee-Problem-Comprehension.pdf"
    >
      Chimpanzee Problem Comprehension: Insufficient Evidence
    </a>
    . 
    <em> Science, 206</em>(4423), 1201-1202. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=14ad96a3-8a8d-3c83-80ea-6bdee2721fe2"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Rumbaugh, D. M. (1980).  Language Analogue
    Project, Phase II: Theory and Tactics.  In K. E. Nelson (Ed.),{" "}
    <em>Children's Language, Volume 2</em> (pp. 267-307). Gardner. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=71e34252-585f-3d2f-a7c6-680d41a53ac2"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Rumbaugh, D. M., &amp; Boysen, S. (1980). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1980-Do-Apes-Use-Language.pdf"
    >
      Do Apes Use Language? One research group considers the evidence for
      representational ability in apes.
    </a>
    <em> American Scientist,68</em>(1), 49-61. 
    <a className="access" href="1980-Do-Apes-Use-Language-Spanish-Trans.pdf">
      Spanish translation
    </a>{" "}
    /
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=0e58cf70-1fd4-3bca-af1b-3220c8296724"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Rumbaugh, D. M., Smith, S. T., &amp; Lawson, J.
    (1980). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1980-Reference-Linguistic-Essential.pdf"
    >
      Reference: The Linguistic Essential.
    </a>
    <em> Science, 210</em>(4472), 922-925. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=2577daac-3acd-3b2b-9f58-b0a7ba2c64b2"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1981).  Can Apes Use Symbols to Represent Their
    World?  In T. A. Sebeok &amp; R. Rosenthal (Eds.),{" "}
    <em>
      The Clever Hans Phenomenon: Communication with Horses, Whales, Apes, and
      People
    </em>{" "}
    (pp. 35-59).  New York Academy of Sciences. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=8c40b628-40e4-3738-9427-c34bcd9aadfc"
    >
      Ebsco
    </a>
  </p>
  <p>
    Teleki, G., Coelho, A. M., Eckhardt, R. B., Fleagle, J. G., Hladik, C. M.,
    Kelso, A. J., McGrew, W. C., Nash, L. T., Nishida, T., Paterson, J. D.,
    Savage-Rumbaugh, S., Smith, E. O., Sugiyama, Y., &amp; Wrangham, R. W.
    (1981). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1981-Variations-Subsistence-Activities.pdf"
    >
      Variations in Subsistence Activities of Female and Male Pongids: New
      Perspectives on the Origins of Hominid Labor Division [and Comments].
    </a>
    <em> Current Anthropology, 22</em>(3), 241-256. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=ca127541-e115-338f-9794-a488879f1c04"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Rumbaugh, D. M. (1982). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1982-ALR-Alive-and-Well.pdf"
    >
      Ape Language Research Is Alive and Well: A Reply.
    </a>
    <em> Anthropos, 77</em>(3/4), 568-573. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=9c208709-fa14-39cf-9648-236b75914229"
    >
      Ebsco
    </a>
  </p>
  <p>
    Rumbaugh, D. M., &amp; Savage-Rumbaugh, S. (1983).  Apes and language
    research. 
    <em>
       Ethics and animals / edited by Harlan B. Miller and William H. Williams
    </em>
    , 207. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=abd10c59-8d54-3685-8145-417c20b2e902"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Pate, J. L., Lawson, J., Smith, S. T., &amp;
    Rosenbaum, S. (1983).  Can a chimpanzee make a statement? 
    <em> Journal of Experimental Psychology: General, 112</em>(4), 457-492. 
    <a className="access" href="https://doi.org/10.1037/0096-3445.112.4.457">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Romski, M. A., Sevcik, R., &amp; Pate, J. L.
    (1983).  Assessing symbol usage versus symbol competency. 
    <em> Journal of Experimental Psychology: General, 112</em>(4), 508-512. 
    <a className="access" href="https://doi.org/10.1037/0096-3445.112.4.508">
      Doi
    </a>
  </p>
  <p>
    Greenfield, P. M., &amp; Savage-Rumbaugh, E. S. (1984).  Perceived
    variability and symbol use: A common language-cognition interface in
    children and chimpanzees (<em>Pan troglodytes</em>). 
    <em> Journal of Comparative Psychology, 98</em>(2), 201-218. 
    <a className="access" href="https://doi.org/10.1037/0735-7036.98.2.201">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1984). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1984-Verbal-Behavior-Procedural.pdf"
    >
      Verbal behavior at a procedural level in the chimpanzee.
    </a>
    <em> Journal of the Experimental Analysis of Behavior, 41</em>(2),
    223-250. 
    <a className="access" href="https://doi.org/10.1901/jeab.1984.41-223">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1984). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1984-Review-Primate-Communication-ESSR.pdf"
    >
      Primate Communication
    </a>
      (review of book by Charles T. Snowdon Charles H. Brown Michael &amp; R.
    Petersen).  In <em>American Scientist, 72</em> 286-288. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=6c446d38-aced-34d6-8e04-568aa6b0d0a1"
    >
      Ebsco
    </a>
  </p>
  <p>
    Menzel, E. W., Jr., Savage-Rumbaugh, E. S., &amp; Lawson, J. (1985). 
    Chimpanzee (<em>Pan troglodytes</em>) spatial problem solving with the use
    of mirrors and televised equivalents of mirrors. 
    <em> Journal of Comparative Psychology, 99</em>(2), 211-217. 
    <a className="access" href="https://doi.org/10.1037/0735-7036.99.2.211">
      Doi
    </a>
  </p>
  <p>
    Parker, S. T., Allik, J., Help, T., Armstrong, D. F., Bloom, A. H., Dorais,
    L.-J., Hewes, G. W., Lieberman, P., Lock, A., Maratsos, M., Mounin, G.,
    Mühlhäusler, P., Rolfe, L. H., Rumbaugh, D. M., Savage-Rumbaugh, E. S.,
    Rumsey, A., Sinha, C. G., &amp; Shunchiu, Y.(1985). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1985-Social-Technological-Model.pdf"
    >
      A Social-Technological Model for the Evolution of Language [and Comments
      and Reply].
    </a>
    <em> Current Anthropology, 26</em>(5), 617-639. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=9c740c9c-3f4e-3daa-98ad-5bb4938c55e3"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Sevcik, R. A., Rumbaugh, D. M., &amp; Rubert, E.
    (1985). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1985-Capacity-To-Acquire.pdf"
    >
      The Capacity of Animals to Acquire Language: Do Species Differences have
      Anything to Say to Us?
    </a>
     
    <em>
       Philosophical Transactions of the Royal Society of London. Series B,
      Biological Sciences,308
    </em>
    (1135), 177-185. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=e81bae25-44b8-38d3-a3ce-675972f77697"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Rumbaugh, D. M., &amp; McDonald, K. (1985).  Language
    learning in two species of apes. 
    <em> Neuroscience and Biobehavioral Reviews, 9</em>(4), 653-665. 
    <a className="access" href="https://doi.org/10.1016/0149-7634(85)90012-0">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1986). 
    <em> Ape language: from conditioned response to symbol</em>.  Columbia
    University Press. 
  </p>
  <p>
    Savage-Rumbaugh, S. (1986).  The Meaning of Primate Signals. Based on a
    Meeting Held in Bad Homburg, January, 1981.  Studies in Emotion and Social
    Interaction, Volume 4. Rom Harre &amp; Vernon Reynolds.  In{" "}
    <em>The Quarterly Review of Biology, 61,</em> 151-152. 
  </p>
  <p>
    Savage-Rumbaugh, S., McDonald, K., Sevcik, R. A., Hopkins, W. D., &amp;
    Rubert, E. (1986). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1986-Spontaneous-Symbol-Acquisition.pdf"
    >
      Spontaneous symbol acquisition and communicative use by pygmy chimpanzees
      (<em>Pan paniscus</em>).
    </a>
    <em> Journal of Experimental Psychology: General, 115</em>(3), 211-235. 
    <a className="access" href="https://doi.org/10.1037/0096-3445.115.3.211">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., McDonald, K., Sevcik, R. A., Hopkins, W. D., &amp;
    Rubert, E. (1986).  Spontaneous Symbol Acquisition and Communicative Use by
    Pygmy Chimpanzees (<em>Pan paniscus</em>). 
    <em>
       Journal of Experimental Psychology: Learning, Memory, and Cognition, 115
    </em>
    (3), 211-235. 
    <a className="access" href="https://doi.org/10.1037/0096-3445.115.3.211">
      Doi
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Savage-Rumbaugh, S., &amp; Hegel, M. T. (1987). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1987-Summation-in-Chimpanzee.pdf"
    >
      Summation in the chimpanzee (<em>Pan troglodytes</em>).
    </a>
    <em> Journal of Experimental Psychology: Animal Learning and Cognition</em>
    ,<em> 13</em>(2), 107-115.{" "}
    <a className="access" href="https://www.ncbi.nlm.nih.gov/pubmed/3572305">
      Pubmed
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1987). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1987-Symbolic-Communication-Language.pdf"
    >
      Communication, symbolic communication, and language: Reply to Seidenberg
      and Pettito.
    </a>
    <em> Journal of Experimental Psychology: General, 116</em>(3), 288-292. 
    <a className="access" href="https://doi.org/10.1037/0096-3445.116.3.288">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1987).  A new look at ape language: comprehension of
    vocal speech and syntax. 
    <em> Nebraska Symposium on Motivation, 35</em>, 201-255. 
    <a className="access" href="https://www.ncbi.nlm.nih.gov/pubmed/3455472">
      Pubmed
    </a>
  </p>
  <p>
    Seidenberg, M. S., Petitto, L. A., &amp; Savage-Rumbaugh, S. (1987). 
    Communication, Symbolic Communication, and Language: Comment on
    Savage-Rumbaugh, McDonald, Sevcik, Hopkins, and Rupert (1986). 
    <em>
       Journal of Experimental Psychology: Learning, Memory, and Cognition, 116
    </em>
    (3), 279-292. 
    <a className="access" href="https://doi.org/10.1037/0096-3445.116.3.279">
      Doi
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Savage-Rumbaugh, E. S., &amp; Pate, J. L. (1988). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1988-Addendum-to-Summation.pdf"
    >
      Addendum to 'Summation in the chimpanzee (<em>Pan troglodytes</em>).'
    </a>
     
    <em>
       Journal of Experimental Psychology: Animal Learning and Cognition, 14
    </em>
    (1), 118-120. 
    <a className="access" href="https://doi.org/10.1037/0097-7403.14.1.118">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1988).  Apes of the World: Their Social Behavior,
    Communication, Mentality, and Ecology Russell H. Tuttle. In{" "}
    <em>American Anthropologist</em> (Vol. 90, pp. 479-480). 
  </p>
  <p>
    Savage-Rumbaugh, S., Sevcik, R. A., &amp; Hopkins, W. D. (1988). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1988-Symbolic-Cross-Modal-Transfer.pdf"
    >
      Symbolic Cross-Modal Transfer in Two Species of Chimpanzees.
    </a>
    <em> Child Development, 59</em>(3), 617-625. 
    <a className="access" href="https://doi.org/10.2307/1130561">
      Doi
    </a>
  </p>
  <p>
    Bolser, L., &amp; Savage-Rumbaugh, S. (1989).  Periparturitional behavior of
    a bonobo (<em>Pan paniscus</em>).  In{" "}
    <em>American journal of primatology</em> (Vol. 17, pp. 93-103). United
    States: Wiley-Blackwell. 
  </p>
  <p>
    Rumbaugh, D. M., Hopkins, W. D., Washburn, D. A., &amp; Savage-Rumbaugh, E.
    S. (1989).  Lana chimpanzee learns to count by "NUMATH": a summary of a
    videotaped experimental report. 
    <em> The Psychological Record, 39</em>(4), 459-470. 
    <a className="access" href="https://doi.org/10.1007/BF03395074">
      Doi
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Richardson, W. K., Washburn, D. A., Savage-Rumbaugh, E. S.,
    &amp; Hopkins, W. D. (1989).  Rhesus monkeys (<em>Macaca mulatta</em>),
    video tasks, and implications for stimulus-response spatial contiguity. 
    <em> Journal of Comparative Psychology, 103</em>(1), 32-38. 
    <a className="access" href="https://doi.org/10.1037/0735-7036.103.1.32">
      Doi
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Washburn, D., &amp; Savage-Rumbaugh, E. S. (1989).  On the
    care of captive chimpanzees: methods of enrichment. 
    <em>
       Housing, care and psychological well-being of captive and laboratory
      primates / edited by Evalyn F. Segal
    </em>
    , 357. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=b7cc8223-d827-367d-8e23-a4128521083a"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1989). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1989-Mother-Infant-Conflict.pdf"
    >
      Mother-infant Conflict; Distal or proximate causes.  Comments on Plooij
      and van de Rijt-Plooij's paper.
    </a>
    <em> European Journal of Psychology of Education, 4</em>(2), 193-194. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=d1b60dde-905f-3536-a4df-6a12c4795a70"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Romski, M. A., D. Hopkins, W., &amp; A. Sevcik, R.
    (1989).  Symbol Acquisition and use by{" "}
    <em>Pan troglodytes, Pan paniscus,</em> &amp; Homo sapiens.  In{" "}
    <em>Understanding Chimpanzees</em> (pp. 266-295).  Cambridge, MA and London,
    England: Harvard University Press. 
  </p>
  <p>
    Richardson, W. K., Washburn, D. A., Hopkins, W. D., Savage-Rumbaugh, E. S.,
    &amp; Rumbaugh, D. M. (1990). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1990-NASA-Computerized-Test.pdf"
    >
      The NASA/LRC Computerized Test System.
    </a>
    <em> Behavior Research Methods, Instruments, &amp; Computers, 22</em>(2),
    127-131. 
    <a className="access" href="https://doi.org/10.3758/bf03203132">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1990).  Language acquisition in a nonhuman species:
    implications for the innateness debate. 
    <em> Developmental Psychobiology, 23</em>(7), 599-620. 
    <a className="access" href="https://doi.org/10.1002/dev.420230706">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1990).  Language as a cause-effect communication
    system. 
    <em> Philosophical Psychology, 3</em>(1), 55. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=0e227aef-9696-3a97-93f9-516c29dc1f06"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1991). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1991-Multi-tasking-Pan-human-Rubicon.pdf"
    >
      Multi-tasking and the <em>Pan</em>-human Rubicon.
    </a>
    <em> Seminars in the Neurosciences, 3,</em> 417-422. 
  </p>
  <p>
    Greenfield, P. M., &amp; Savage-Rumbaugh, E. S. (1991).  Imitation,
    Grammatical Development, and the Invention of Protogrammar by an Ape.  In N.
    A. Krasnegor, D. M. Rumbaugh, R. L. Schiefelbusch, &amp; M. Studdert-Kennedy
    (Eds.),
    <em>
       Biological and Behavioral Determinants of Language Development
    </em>{" "}
    (pp. 235-258).  Lawrence Erlbaum Associates. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=3ad0dda9-ba0a-3705-b44c-69913acb70fd"
    >
      Ebsco
    </a>
  </p>
  <p>
    Hopkins, W. D., Morris, R. D., &amp; Savage-Rumbaugh, E. S. (1991). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1991-Evidence-Asymmetrical-Priming.pdf"
    >
      Evidence for asymmetrical hemispheric priming using known and unknown
      warning stimuli in two language-trained chimpanzees (
      <em>Pan troglodytes</em>).
    </a>
    <em> Journal of Experimental Psychology: General, 120</em>(1), 46-56.{" "}
    <a className="access" href="https://doi.org/10.1037//0096-3445.120.1.46">
      Doi
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Hopkins, W. D., Washburn, D. A., &amp; Savage-Rumbaugh, E.
    S. (1991).  Comparative Perspectives of Brain, Cognition, and Language.  In
    N. A. Krasnegor, D. M. Rumbaugh, R. L. Schiefelbusch, &amp; M.
    Studdert-Kennedy (Eds.),
    <em>
       Biological and Behavioral Determinants of Language Development
    </em>{" "}
    (pp. 145-164).  Lawrence Erlbaum Associates. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=4a2c0aa5-bfc2-3634-b524-6605aa98da6b"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1991).  Language Learning in the Bonobo: How and Why
    They Learn.  In N. A. Krasnegor, D. M. Rumbaugh, R. L. Schiefelbusch, &amp;
    M. Studdert-Kennedy (Eds.),
    <em>
       Biological and Behavioral Determinants of Language Development
    </em>{" "}
    (pp. 209-233).  Lawrence Erlbaum Associates. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=36718a80-f9db-30a9-9f79-3a71e9154faa"
    >
      Ebsco
    </a>
  </p>
  <p>
    Brakke, K.E., &amp; Savage-Rumbaugh, E.S. (1991). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1991-Early-postural-behavior-Pan.pdf"
    >
      Early postural behavior in <em>Pan</em>: Influences on Development.
    </a>
    <em> Infant Behavior and Development, 14</em>, 265-288. 
  </p>
  <p>
    Hopkins, W. D., &amp; Savage-Rumbaugh, E.S. (1991). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1991-Vocal-Communication-Rearing.pdf"
    >
      Vocal communication as a function of differential rearing experiences in{" "}
      <em>Pan paniscus:</em> A preliminary report.
    </a>
    <em> International Journal of Primatology, 12</em> (6), 559-583. 
  </p>
  <p>
    Hopkins, W. D., Morris, R. D., Savage-Rumbaugh, E. S., &amp; Rumbaugh, D. M.
    (1992). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1992-Hemispheric-Priming-Meaningful.pdf"
    >
      Hemispheric priming by meaningful and nonmeaningful symbols in
      language-trained chimpanzees (<em>Pan troglodytes</em>): further evidence
      of a left hemisphere advantage.
    </a>
    <em> Behavioral Neuroscience, 106</em>(3), 575-582. 
    <a className="access" href="https://doi.org/10.1037//0735-7044.106.3.575">
      Doi
    </a>
  </p>
  <p>
    Greenfield, P. M., &amp; Savage-Rumbaugh, E. S. (1993).  Comparing
    Communicative Competence in Child and Chimp: The Pragmatics of Repetition. 
    <em> Journal of Child Language, 20</em>(1), 1-26. 
    <a className="access" href="https://doi.org/10.1017/S0305000900009090">
      Doi
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Hopkins, W., Washburn, D. A., &amp; Savage-Rumbaugh, E. S.
    (1993).  Chimpanzee Competence for Comprehension Video-Formatted Task
    Situation.  In H. L. Roitblat, L. M. Herman, &amp; P. E. Nachtigall (Eds.),
    <em> Language and Communication: Comparative Perspectives</em> (pp.
    329-346).  Lawrence Erlbaum Associates. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=f5e0add3-fe3c-3aa7-80de-905f095f0310"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1993).  How Does Evolution Design a Brain Capable of
    Learning Language? 
    <em> Monographs of the Society for Research in Child Development, 58</em>,
    243-252. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=61005e59-b293-31d5-8b91-d287d17ffd70"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1993).  Language Learnability in Man, Ape, and
    Dolphin.  In H. L. Roitblat, L. M. Herman, &amp; P. E. Nachtigall (Eds.),
    <em> Language and Communication: Comparative Perspectives</em> (pp.
    457-484).  Lawrence Erlbaum Associates. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=30e137cc-21bc-3e5b-95e7-66501d5562b6"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Murphy, J., Sevcik, R. A., Brakke, K. E., Williams,
    S. L., Rumbaugh, D. M., &amp; Bates, E. (1993). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1993-Language-Comprehension-Ape.pdf"
    >
      Language Comprehension in Ape and Child.
    </a>
    <em> Monographs of the Society for Research in Child Development, 58</em>
    (3/4), i-252. 
    <a className="access" href="https://doi.org/10.2307/1166068">
      Doi
    </a>
  </p>
  <p>
    Tomasello, M., Savage-Rumbaugh, S., &amp; Kruger, A. C. (1993). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1993-Imitative-Learning-Actions.pdf"
    >
      Imitative Learning of Actions on Objects by Children, Chimpanzees, and
      Enculturated Chimpanzees.
    </a>
    <em> Child Development, 64</em>(6), 1688-1705. 
    <a className="access" href="https://doi.org/10.2307/1131463">
      Doi
    </a>
  </p>
  <p>
    Toth, N., Schick, K. D., Savage-Rumbaugh, E. S., &amp; Sevcik, R. A.(1993). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1993-Pan-Tool-Maker.pdf"
    >
      Pan the Tool-Maker: Investigations into the Stone Tool-Making and
      Tool-Using Capabilities of a Bonobo (<em>Pan paniscus</em>).
    </a>
      Journal of Archaeological Science, Great Britain. 
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Lewin, R. (1994). 
    <em> Kanzi : the Ape at the Brink of the Human Mind</em>.  Wiley. 
    <a
      className="access"
      href="http://www.loc.gov/catdir/description/wiley033/94009038.html"
    >
      Publisher Description
    </a>
      /
    <a
      className="access"
      href="http://www.loc.gov/catdir/toc/onix04/94009038.html"
    >
      Table of Contents
    </a>
     
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1994).  Hominid evolution: Looking to modern apes
    for clues.  In D. Quiatt and J. Itani (Eds.),{" "}
    <em>Hominid Culture in Primate Perspective.</em>.  Niwot, CO: University
    Press of Colorado. 
  </p>
  <p>
    Sevcik, R. A., &amp; Savage-Rumbaugh, S. (1994).  Language Comprehension and
    Use by Great Apes. 
    <em> Language &amp; Communication, 14</em>(1), 37-58. 
    <a className="access" href="https://doi.org/10.1016/0271-5309(94)90019-1">
      Doi
    </a>
  </p>
  <p>
    Brakke, K. E., &amp; Savage-Rumbaugh, E. S. (1995). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1995-Development-Language-Skills-I.pdf"
    >
      The Development of Language Skills in Bonobo and Chimpanzee--I.
      Comprehension.
    </a>
    <em> Language &amp; Communication, 15</em>, 121-148. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=a019a39b-9ab5-332c-88e1-855cfe5001e5"
    >
      Ebsco
    </a>
  </p>
  <p>
    Carpenter, M., Tomasello, M., &amp; Savage-Rumbaugh, S. (1995).  Joint
    Attention and Imitative Learning in Children, Chimpanzees and Enculturated
    Chimpanzees. 
    <em> Social Development, 4</em>(3), 217-237. 
    <a
      className="access"
      href="https://doi.org/10.1111/j.1467-9507.1995.tb00063.x"
    >
      Doi
    </a>
  </p>
  <p>
    Visalberghi, E., Fragaszy, D. M., &amp; Savage-Rumbaugh, S. (1995). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1995-Performance-Tool-Using-Task.pdf"
    >
      Performance in a tool-using task by common chimpanzees (
      <em>Pan troglodytes</em>), bonobos (<em>Pan paniscus</em>), an orangutan (
      <em>Pongo pygmaeus</em>), and capuchin monkeys (<em>Cebus apella</em>).
    </a>
    <em> Journal of Comparative Psychology, 109</em>(1), 52-60. 
    <a className="access" href="https://doi.org/10.1037/0735-7036.109.1.52">
      Doi
    </a>
  </p>
  <p>
    Brakke, K. E., &amp; Savage-Rumbaugh, E. S. (1996). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1996-Dev-Language-Skill-II.pdf"
    >
      The development of language skills in PAN - II. Production.
    </a>
    <em> Language &amp; Communication, 16</em>(4), 361-380. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=0ca71d32-b7ad-382b-ad92-128bc9f25884"
    >
      Ebsco
    </a>
  </p>
  <p>
    Langs, R., Badalamenti, A. F., &amp; Savage-Rumbaugh, S. (1996).  Two
    mathematically defined expressive language structures in humans and
    chimpanzees. 
    <em> Behavioral Science, 41</em>(2), 124-135. 
    <a className="access" href="https://doi.org/10.1002/bs.3830410203">
      Doi
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Savage-Rumbaugh, E. S., &amp; Washburn, D. A. (1996). 
    Toward a new outlook on primate learning and behavior: complex learning and
    emergent processes in comparative perspective. 
    <em> Japan Psychological Research, 38</em>(3), 113-125. 
    <a
      className="access"
      href="https://doi.org/10.1111/j.1468-5884.1996.tb00016.x"
    >
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1996).  On display. 
    <em> SuperScience Blue, 7</em>(5), 12. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=4b506242-91b8-34e8-a2e2-a38420a29f7a"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Shanker, S., &amp; Taylor, T. J. (1996).  Apes with
    language. <em>Critical Quarterly, 38</em>(3), 45-57. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=ec84d913-db04-3ae8-bea9-eba16377a9ef"
    >
      Ebsco
    </a>
  </p>
  <p>
    Sue, S.-R. (1996). 
    <em> Kanzi : The Ape at the Brink of the Human Mind</em>.  Trade Paper
    Press. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=82419113-866b-3631-b329-7e376b29945a"
    >
      Ebsco
    </a>
  </p>
  <p>
    Rumbaugh, D. M., &amp; Savage-Rumbaugh, E. S. (1997).  A Comparative
    Perspective on the Etiology of Meaning and Assaying Behaviors for Meaning. 
    <em> Advances in Psychology, 122</em>, 147-180. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=a8e797af-3e4c-3d70-b7d3-9bc2ef23fa85"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1997).  Primates who think or ape? 
    <em> Times Higher Education Supplement</em>(1280), 25. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=ea9f1905-d998-321c-bbb6-46a0544c2d13"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S. (1997).  Why are we afraid of apes with language?  In
    A. B. Scheibel and J. W. Schopf (Eds.),{" "}
    <em>The Origin and Evolution of Intelligence</em>.  Sudbury MA: Jones and
    Bartlett. 
  </p>
  <p>
    Savage-Rumbaugh, S. (1997).  Book review. 
    <em> International Journal of Primatology, 18</em>(5), 847. 
    <a className="access" href="https://doi.org/10.1023/A:1026312400684">
      Doi
    </a>
  </p>
  <p>
    Williams, S. L., Brakke, K. E., &amp; Savage-Rumbaugh, E. S. (1997). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1997-Comprehension-Skills-Language.pdf"
    >
      Comprehension skills of language-competent and nonlanguage-competent apes.
    </a>
    <em> Language &amp; Communication, 17</em>(4), 301-318. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=68f8f951-f834-3b01-aa6f-dd14d3291bd0"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Shanker, S. G., &amp; Taylor, T. J. (1998). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1998-Beyond-Speciesism.pdf"
    >
      Beyond Speciesism.
    </a>
    <em> Apes, Language, and the Human Mind</em> (pp. 181-228). Oxford
    University Press. 
    <a className="access" href="https://scholarworks.wm.edu/asbookchapters/135">
      ScholarWorks
    </a>
     
  </p>
  <p>
    Beran, M. J., Rumbaugh, D. M., &amp; Savage-Rumbaugh, E. S. (1998). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1998-Chimpanzee-Counting.pdf"
    >
      Chimpanzee (<em>Pan troglodytes</em>) Counting in a Computerized Testing
      Paradigm.
    </a>
    <em> The Psychological Record, 48</em>(1), 3-20. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=5b058683-b228-3c4e-9acd-36bcea7aeb33"
    >
      Ebsco
    </a>
  </p>
  <p>
    Beran, M. J., Savage-Rumbaugh, E. S., Brakke, K. E., Kelley, J. W., &amp;
    Rumbaugh, D. M. (1998).  Symbol Comprehension and Learning: A 'Vocabulary'
    Test of Three Chimpanzees (<em>Pan troglodytes</em>). 
    <em>
       Evolution of Communication: An International Multidisciplinary Journal, 2
    </em>
    (2), 171-188. 
    <a className="access" href="https://doi.org/10.1075/eoc.2.2.02ber">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Shanker, S., &amp; Taylor, T. J. (1998). 
    <em> Apes, Language, and the Human Mind</em>.  Oxford University Press. 
    <a
      className="access"
      href="http://www.loc.gov/catdir/enhancements/fy0603/98014600-d.html"
    >
      Publisher Description
    </a>
      /
    <a
      className="access"
      href="http://www.loc.gov/catdir/enhancements/fy0603/98014600-t.html"
    >
      Table of Contents
    </a>
     
  </p>
  <p>
    Beran, M. J., Savage-Rumbaugh, E. S., Pate, J. L., &amp; Rumbaugh, D. M.
    (1999). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1999-Delay-Gratification-Chimpanzees.pdf"
    >
      Delay of gratification in chimpanzees (<em>Pan troglodytes</em>).
    </a>
    <em> Dev Psychobiol, 34</em>(2), 119-127. 
    <a
      className="access"
      href="https://doi.org/10.1002/(sici)1098-2302(199903)34:2<119::aid-dev5>3.0.co;2-p"
    >
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1999).  WHY I...believe that one day apes will have a
    nation of their own. 
    <em> Times Higher Education Supplement</em>(1395), 16. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=b61e8256-0307-3030-9a20-882981525eaa"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (1999).  Between a Rock and Hard Place.  In B. J. King
    (Ed.), <em>The Origins of Language: What Nonhuman Primates Can Tell Us</em>{" "}
    (pp. 115-188).  University of New Mexico Press. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=c777293d-7a95-3d74-b238-4235b0b5fbd2"
    >
      Ebsco
    </a>
  </p>
  <p>
    Potì, P., Langer, J., Savage-Rumbaugh, S., &amp; Brakke, K.E. (1999). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1999-Spontaneous-Logicomathematical.pdf"
    >
      Spontaneous logicomathematical constructions by chimpanzees (
      <em>Pan troglodytes, Pan paniscus</em>).
    </a>
    <em> Animal Cognition, 2</em>, 147–156. 
  </p>
  <p>
    Schick, K. D., Toth, N., Garufi, G., Savage-Rumbaugh, E. S., Rumbaugh, D.,
    &amp; Sevcik, R. (1999). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1999-Investigations-Stone-Tool.pdf"
    >
      Continuing Investigations into the Stone Tool-making and Tool-using
      Capabilities of a Bonobo (<em>Pan paniscus</em>).
    </a>
    <em> Journal of Archeological Science, 26</em>(7), 821-832. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=431f6314-00e7-32f1-ab6e-9c805e7439c9"
    >
      Ebsco
    </a>
  </p>
  <p>
    Shanker, S. G., Savage-Rumbaugh, E. S., &amp; Taylor, T. J. (1999). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/1999-Kanzi-New-Beginning.pdf"
    >
      Kanzi: A New Beginning.
    </a>
    <em> Animal Learning and Behavior</em>, <em>27</em>(1), 24-25. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=4559d8db-8b0b-3bc1-bb10-43b5f9f4b57c"
    >
      Ebsco
    </a>
  </p>
  <p>
    Lyn, H., &amp; Savage-Rumbaugh, E. S. (2000). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2000-Observational-Word-Learning-Bonobos.pdf"
    >
      Observational Word Learning in Two Bonobos (<em>Pan Paniscus</em>):
      Ostensive and Non-Ostensive Contexts.
    </a>
    <em> Language &amp; Communication, 20</em>(3), 255-273. 
    <a className="access" href="https://doi.org/10.1016/S0271-5309(99)00026-9">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Fields, W. M. (2000). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2000-Linguistic-Cultural-Cognitive-Capacities.pdf"
    >
      Linguistic, Cultural and Cognitive Capacities of Bonobos (
      <em>Pan paniscus</em>).
    </a>
    <em> Culture and Psychology, 6</em>(2), 131-154. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=938cf74a-8e44-3dd4-99eb-8da42ddac260"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Fields, W. M. (2000). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2000-Review-Cultural-Origins-ESSR.pdf"
    >
      The Cultural Origins of Human Cognition (Book Review).
    </a>
    <em> American Anthropologist, 102</em>(4), 925. 
    <a className="access" href="https://doi.org/10.1525/aa.2000.102.4.925">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (2000). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2000-Ape-Human-Consciousness.pdf"
    >
      Ape Consciousness-Human Consciousness: A Perspective Informed by Language
      and Culture.
    </a>
    <em> American Zoologist, 40</em>(6), 910-921. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=c31d550b-9799-3530-9c2b-7a835a0679eb"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Fields, W. M., &amp; Taglialatila, J. (2001). 
    Language, Speech, Tools and Writing: A Cultural Imperative. 
    <em> Journal of Consciousness Studies, 8</em>(5/7), 273-292. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=7267ca3b-ac27-3b28-89c2-d9587d7c2c05"
    >
      Ebsco
    </a>
  </p>
  <p>
    Benson, J., Fries, P., Greaves, W., Iwamoto, K., Savage-Rumbaugh, S., &amp;
    Taglialatela, J. (2002). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2002-Confrontatiions-Support-Discourse.pdf"
    >
      Confrontation and support in bonobo-human discourse.
    </a>
    <em> Functions of Language, 9</em>(1), 1-38. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=41819a21-c93a-3fc9-949e-39faa4155bd7"
    >
      Ebsco
    </a>
  </p>
  <p>
    Menzel, C. R., Savage-Rumbaugh, E. S., &amp; Menzel Jr, E. W. (2002). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2002-Bonobo-Spatial-Memory.pdf"
    >
      Bonobo (<em>Pan paniscus</em>) Spatial Memory and Communication in a
      20-hectare Forest.
    </a>
    <em> International Journal of Primatology, 23</em>(3), 601-619. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=d0cfccb8-c63c-3bb9-910d-ef2e75640ec9"
    >
      Ebsco
    </a>
  </p>
  <p>
    Fields, W. M., &amp; Savage-Rumbaugh, S. (2003).  A Mind So Rare: The
    Evolution of Human Consciousness by Merlin W. Donald. 
    <em> Contemporary Psychology, 48</em>(5), 596-597. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=6dd39bba-0186-3b21-aa7f-b448f733a90c"
    >
      Ebsco
    </a>
  </p>
  <p>
    Taglialatela, J. P., Savage-Rumbaugh, S., &amp; Baker, L. A. (2003). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2003-Vocal-Production-Paniscus.pdf"
    >
      Vocal Production by a Language-Competent <em>Pan paniscus</em>.
    </a>
    <em> International Journal of Primatology, 24</em>(1), 1-17. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=eca57b9e-fbf7-37df-9f45-01f62a6d7274"
    >
      Ebsco
    </a>
  </p>
  <p>
    Benson, J. D., Debashish, M., Greaves, W. S., Lukas, J., Savage-Rumbaugh,
    S., &amp; Taglialatela, J. (2004). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2004-Mind-brain-Apes.pdf"
    >
      Mind and brain in apes: a methodology for phonemic analysis of
      vocalizations of language competent bonobos.
    </a>
    <em> Language Sciences, 26</em>(6), 643-660. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=3d834693-0f50-3e9f-b360-068f1047a531"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Rumbaugh, D. M. (2004).  Book Review: My
    Family Album. By Frans de Waal. 
    <em> International Journal of Primatology, 25</em>(4), 979-980. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=213fdce1-064b-3af3-a446-5d435d9eda5f"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Fields, W. M., &amp; Spircu, T. (2004).  The emergence
    of knapping and vocal expression embedded in a Pan/Homo culture. 
    <em> Biology &amp; Philosophy, 19</em>(4), 541-575. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=890f0fff-215b-3c55-ae78-e68910ef0640"
    >
      Ebsco
    </a>
  </p>
  <p>
    Taglialatela, J. P., Savage-Rumbaugh, S., Rumbaugh, D. M., Benson, J., &amp;
    Greaves, W. (2004).  Language, Apes and Meaning-Making.  In G. Williams
    &amp; A. Lukin (Eds.),{" "}
    <em>
      The Development of Language: Functional Perspectives on Species and
      Individuals
    </em>{" "}
    (pp. 91-111).  Frances Pinter. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=547cd9c4-8066-3d55-ac56-4b63f91a6c54"
    >
      Ebsco
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Beran, M. J., &amp; Savage-Rumbaugh, E. S. (2005). 
    Language.  In <em>Primate Psychology</em> (Vol. 14, pp. 395-423). 
    Cambridge, MA and London, England: Harvard University Press. 
  </p>
  <p>
    Savage, R., Fields, &amp; Spiricu. (2005).  In Savage-Rumbaugh, Fields, and
    Spiricu (vol 19, pg 541, 2005). 
    <em> Biology &amp; Philosophy, 20</em>(1), 191-191. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=2f8257b1-2402-38ac-b7aa-7a464f9f7adb"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Fields, W. M., Segerdahl, P., &amp; Rumbaugh, D.
    (2005). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2005-Culture-Prefigures-Cognition.pdf"
    >
      Culture Prefigures Cognition in Pan/Homo Bonobos.
    </a>
     
    <em>
       THEORIA. An International Journal for Theory, History and Foundations of
      Science, 20
    </em>
    (3), 311-328. 
    <a className="access" href="https://doi.org/10.1387/theoria.565">
      Doi
    </a>
  </p>
  <p>
    Segerdahl, P., Fields, W., &amp; Savage-Rumbaugh, S. (2005). 
    <em>
       Kanzi's Primal Language: The Cultural Initiation of Primates into
      Language
    </em>
    .  New York, NY: Palgrave Macmillan. 
    <a className="access" href="https://doi.org/10.1057/9780230513389">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., &amp; Fields, W. M. (2006). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2006-Rules-and-Tools.pdf"
    >
      Rules and tools: Beyond anthropomorphism.
    </a>
      In N. Toth &amp; K. Schick (Eds.),{" "}
    <em>The Oldowan: Case Studies into the Earliest Stone Age (Vol. 1)</em>,
    Gosport, In. Stone Age Institute Press. 
  </p>
  <p>
    Lyn, H., Greenfield, P., &amp; Savage-Rumbaugh, S. (2006). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2006-Development-Representational-Play.pdf"
    >
      The Development of Representational Play in Chimpanzees and Bonobos:
      Evolutionary Implications, Pretense, and the Role of Interspecies
      Communication.
    </a>
    <em> Cognitive Development, 21</em>(3), 199-213. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=a2b60102-6d2a-3895-80f4-3e0333749f64"
    >
      Ebsco
    </a>
  </p>
  <p>
    Fields, W. M., Segerdahl, P., &amp; Savage-Rumbaugh, S. (2007). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2007-Material-Practices.pdf"
    >
      The material practices of ape language research.
    </a>
      In Jaan Valsiner &amp; Alberto Rosa (Eds.), The Cambridge Handbook of
    Sociocultural Psychology.  New York: Cambridge University Press. 
  </p>
  <p>
    Maple, T. L., Lonsdorf, E. V., Seelig, D., &amp; Savage-Rumbaugh, S.
    (2007).  Full panel discussion. 
    <em> J Applied Animal Welfare Sci, 10</em>(1), 87-93. 
    <a className="access" href="https://doi.org/10.1080/10888700701277758">
      Doi
    </a>
  </p>
  <p>
    Rumbaugh, D. M., Savage-Rumbaugh, E. S., &amp; King, J. E. (2007).  Dorothy
    L. Cheney and Robert M. Seyfarth: Baboon Metaphysics. 
    <em> International Journal of Primatology, 28</em>(5), 1173-1174. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=23bef7c0-961b-37b8-95dc-8f09e47ef2d4"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Wamba, K., Wamba, P., &amp; Wamba, N. (2007).  Welfare
    of apes in captive environments: comments on, and by, a specific group of
    apes. 
    <em> J Appl Anim Welf Sci, 10</em>(1), 7-19. 
    <a className="access" href="https://doi.org/10.1080/10888700701277261">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Wamba, K., Wamba, P., &amp; Wamba, N. (2007).  Welfare
    of Apes in Captive Environments: Comments On, and By, a Specific Group of
    Apes.  In Greenfield, P. M., Lyn, H., &amp; Savage-Rumbaugh, E. S. (2008). 
    Protolanguage in Ontogeny and Phylogeny: Combining Deixis and
    Representation. 
    <em>
       Interaction Studies: Social Behavior and Communication in Biological and
      Artificial Systems, 9
    </em>
    (1), 34-50. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=bd14af80-2ae7-3d8a-ae94-3677d9b25761"
    >
      Ebsco
    </a>
  </p>
  <p>
    Lyn, H., Franks, B., &amp; Savage-Rumbaugh, E. S. (2008). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2008-Precursors-of-Morality.pdf"
    >
      Precursors of Morality in the Use of the Symbols 'Good' and 'Bad' in Two
      Bonobos (<em>Pan Paniscus</em>) and a Chimpanzee (<em>Pan Troglodytes</em>
      ).
    </a>
    <em> Language &amp; Communication, 28</em>(3), 213-224. 
    <a className="access" href="https://doi.org/10.1016/j.langcom.2008.01.006">
      Doi
    </a>
  </p>
  <p>
    Givón, T. and Savage-Rumbaugh, S. (2009).  Teaching grammar to apes.  In J.
    Guo, E. Lieven, N. Budwis, K. Nakamura, &amp; S. Ozkaliskan (Eds.),
    <em>
       Cross-linguistic Approaches to the Psychology of Language: Research in
      the Tradition of Dan Isaac Slobin,
    </em>
    NY/London: Psychology Press. 
  </p>
  <p>
    Ragir, S., &amp; Savage-Rumbaugh, S. (2009).  Playing with meaning:
    normative function and structure in play. 
    <em> Studies in the Evolution of Language, 11</em>, 122-141. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=0576f1f4-21eb-338e-b341-45b2b11f345d"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., Rumbaugh, D., &amp; Fields, W. M. (2009). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2009-Empirical-Kanzi.pdf"
    >
      Empirical Kanzi: The Ape Language Controversy Revisited.
    </a>
    <em> Skeptic, 15</em>(1), 25-33. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=8906c777-8b10-3761-b160-2892c30e9264"
    >
      Ebsco
    </a>
  </p>
  <p>
    Greenfield, P. M., Lyn, H., &amp; Savage-Rumbaugh, E. S. (2010). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2008-Protolanguage-Ontology-Phylogeny.pdf"
    >
      Protolanguage in Ontogeny and Phylogeny: Combining Deixis and
      Representation.
    </a>
      In M. A. Arbib &amp; D. Bickerton (Eds.),
    <em>
       The Emergence of Protolanguage: Holophrasis vs. Compositionality
    </em>{" "}
    (pp. 35-50).  John Benjamins Publishing Company. 
    <a className="access" href="https://doi.org/10.1075/bct.24.03gre">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., Fields, W. M., &amp; Segerdahl, P. (2010).  Culture
    Prefigures Cognition in Pan/Homo Bonobos. 
    <em> Theoria, 20</em>, 311-328. 
    <a className="access" href="https://doi.org/10.1387/theoria.565">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S. (2010).  The bonobos' secret. 
    <em> New Scientist, 206</em>(2765), 03-03. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=1301f9fe-31a0-3025-ab5e-cc9c674b3b44"
    >
      Ebsco
    </a>
  </p>
  <p>
    Lyn, H., Greenfield, P. M., &amp; Savage-Rumbaugh, E. S. (2010). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2010-Semiotic-Combinations-Pan.pdf"
    >
      Semiotic Combinations in <em>Pan</em>: A Comparison of Communication in a
      Chimpanzee and Two Bonobos.
    </a>
    <em> First Language, 31</em>(3 [97]), 300-325. 
    <a className="access" href="https://doi.org/10.1177/0142723710391872">
      Doi
    </a>
  </p>
  <p>
    Gillespie-Lynch, K., Greenfield, P. M., Lyn, H., &amp; Savage-Rumbaugh, S.
    (2011). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2011-Dialogue-Ontogeny-Phylogeny.pdf"
    >
      The role of dialogue in the ontogeny and phylogeny of early symbol
      combinations: A cross-species comparison of bonobo, chimpanzee, and human
      learners.
    </a>
    <em> First Language, 31</em>(4), 442-460. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=33c7d20f-d5b1-3328-b36b-810a6669ed86"
    >
      Ebsco
    </a>
  </p>
  <p>
    Lyn, H., Greenfield, P. M., Savage-Rumbaugh, S., Gillespie-Lynch, K., &amp;
    Hopkins, W. D. (2011). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2011-Primates-do-Declare.pdf"
    >
      Nonhuman Primates do Declare! A Comparison of Declarative Symbol and
      Gesture Use in Two Children, Two Bonobos, and A Chimpanzee.
    </a>
    <em> Language Communication, 31</em>(1), 63-74. 
    <a className="access" href="https://doi.org/10.1016/j.langcom.2010.11.001">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Fields, W. M. (2011). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2011-Evolution-Rise-Language.pdf"
    >
      The Evolution and the Rise of Human Language: Carry the Baby.
    </a>
      In C. S. Henshilwood &amp; F. D'Errico (Eds.),
    <em>
       Homo Symbolicus: The Dawn of Language, Imagination and Spirituality
    </em>{" "}
    (pp. 13-47).  John Benjamins Publishing Company. 
    <a className="access" href="2012-Evolution-Rise-Language-French.pdf">
      French translation
    </a>
      /
    <a className="access" href="https://doi.org/10.1075/z.168.02sav">
      Doi
    </a>
  </p>
  <p>
    Roffman, I., Savage-Rumbaugh, S., Rubert-Pugh, E., Ronen, A., &amp; Nevo, E.
    (2012). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2012-Stone-Tool-Production.pdf"
    >
      Stone tool production and utilization by bonobo-chimpanzees (Pan
      paniscus).
    </a>
    <em> Proceedings of the National Academy of Sciences, 109</em>(36),
    14500-14503. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=2fffa82c-59c3-3220-b30b-ad811932cc40"
    >
      Ebsco
    </a>
  </p>
  <p>
    Savage-Rumbaugh, E. S., &amp; Fields, W. M. (2013). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2013-Human-uniqueness.pdf"
    >
      Human uniqueness–Constructions of ourselves and our sibling species: Pan
      troglodytes and Pan paniscus.
    </a>
     
    <em>
       Quo Vadis, Behavioural Biology? Past, Present, and Future of an Evolving
      Science, 111
    </em>
    (380), 205-226. 
  </p>
  <p>
    Gillespie-Lynch, K., Greenfield, P. M., Feng, Y., Savage-Rumbaugh, E.S.,
    &amp; Lyn, H. (2013). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2013-Cross-Species-Gesture.pdf"
    >
      A cross-species study of gesture and its role in symbolic development:
      implications for the gestural theory of language evolution.
    </a>
    <em> Frontiers in Psychology, 4</em>, 160. 
    <a className="access" href="https://doi.org/10.3389/fpsyg.2013.00160">
      Doi
    </a>
  </p>
  <p>
    McGowen, M. R., Weckle, A., Agnew, D., Benirschke, K., Savage-Rumbaugh, S.,
    Kim, C. J., Wagner, G. P., Romero, R., &amp; Wildman, D. E. (2013).  Gene
    expression in the term placenta of the opossum{" "}
    <em>Monodelphis domestica</em> and the evolution of the therian placenta. 
    <em> Placenta, 34</em>(9), A24-A25. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=07681c22-20bf-3588-be17-0f087db2ac50"
    >
      Ebsco
    </a>
  </p>
  <p>
    Gillespie-Lynch, K., Greenfield, P. M., Lyn, H., &amp; Savage-Rumbaugh, S.
    (2014). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2014-Gestural-Symbolic-Development.pdf"
    >
      Gestural and symbolic development among apes and humans: support for a
      multimodal theory of language evolution.
    </a>
    <em> Frontiers in Psychology, 5</em>, 1228. 
    <a className="access" href="https://doi.org/10.3389/fpsyg.2014.01228">
      Doi
    </a>
  </p>
  <p>
    Gillespie-Lynch, K., Savage-Rumbaugh, S. &amp; Lyn, H. (2014). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2014-Language-Learning-Primates.pdf"
    >
      Language Learning in Non-human Primates
    </a>
      In: P. J. Brooks &amp; V. Kempe (Eds.).{" "}
    <em>Encyclopedia of Language Development.</em>
    Sage Press. 
  </p>
  <p>
    Roffman, I., Savage-Rumbaugh, S., Rubert-Pugh, E., Stadler, A., Ronen, A.,
    &amp; Nevo, E. (2015). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2015-Preparation-Natural-Tools.pdf"
    >
      Preparation and use of varied natural tools for extractive foraging by
      bonobos (<em>Pan Paniscus</em>).
    </a>
    <em> American Journal of Physical Anthropology, 158</em>(1), 78-91. 
    <a className="access" href="https://doi.org/10.1002/ajpa.22778">
      Doi
    </a>
  </p>
  <p>
    Armstrong, D. L., McGowen, M. R., Weckle, A., Caravas, J., Agnew, D.,
    Savage-Rumbaugh, S., Nevo, E., Kim, C. J., Wagner, G. P., Romero, R., &amp;
    Wildman, D. (2016). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2016-Evolution-Gene-Expression-Poster.pdf"
    >
      The evolution of gene expression in the term placenta of{" "}
      <em>Viviparous</em> mammals.
    </a>
      (Poster) Institute for Genomic Biology, Computing Genomes for Reproductive
    Health, University of Illinois, Urbana-Champaign. 
  </p>
  <p>
    Savage-Rumbaugh, S., Segerdahl, P., &amp; Fields, W. M. (2017). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2017-Ind-Diffs-Language-Competencies.pdf"
    >
      Individual differences in language competencies in apes resulting from
      unique rearing conditions imposed by different first epistemologies.
    </a>
      In Laura L. Namy (Ed.), <em>Symbol use and symbolic representation</em>{" "}
    (pp. 200-220).  Psychology Press. 
  </p>
  <p>
    Armstrong, D. L., McGowen, M. R., Weckle, A., Pantham, P., Caravas, J.,
    Agnew, D., Benirschke, K., Savage-Rumbaugh, S., Nevo, E., Kim, C. J.,
    Wagner, G. P., Romero, R., &amp; Wildman, D. E. (2017). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2017-Core-Transcriptome-Placenta.pdf"
    >
      The core transcriptome of mammalian placentas and the divergence of
      expression with placental shape.
    </a>
    <em> Placenta, 57</em>, 71-78. 
    <a className="access" href="https://doi.org/10.1016/j.placenta.2017.04.015">
      Doi
    </a>
  </p>
  <p>
    Savage-Rumbaugh, S., &amp; Roffman, I. (2018). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2018-Advent-of-selfhood.pdf"
    >
      Advent of selfhood.
    </a>
    <em> Journal of Veterinary Medicine and Animal Sciences</em>
  </p>
  <p>
    Savage-Rumbaugh, S., Roffman, I., Lingomo, S., &amp; Pugh, E. (2018). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2018-Fully-Conscious-Ape.pdf"
    >
      The Fully Conscious Ape.
    </a>
    <em> International Journal of Comparative Psychology, 31</em>, 1-62. 
    <a className="access" href="https://doi.org/10.46867/ijcp.2018.31.03.03">
      Doi
    </a>
  </p>
  <p>
    Dubreuil, L., &amp; Savage-Rumbaugh, S. (2019). 
    <em> Dialogues on the Human Ape</em>.  University of Minnesota Press. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=26e524b5-ef9e-3182-976f-5e0dba48828b"
    >
      Ebsco
    </a>
  </p>
  <p>
    Gillespie-Lynch, K. M., Savage-Rumbaugh, E. S., Lyn, H., &amp; Greenfield,
    P. (2019). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2019-Language-Growth-Hands-Mouths.pdf"
    >
      What did language grow from? Ape hands, mouths, or both?
    </a>
    <em> Frontiers in Neuroscience for Young Minds</em>
  </p>
  <p>
    Roffman, I., Mizrachi, Y., Chiarelli, B., Savage-Rumbaugh, S., Rubert-Pugh,
    E., Fontaine, L., Panchevre, M., Ronen, A., &amp; Nevo, E. (2019). 
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="pdf/2019-Pan Survival.pdf"
    >
      Pan Survival in the 21st Century: Chimpanzee Cultural Preservation,
      Rehabilitation, and Emancipation Manifesto.
    </a>
    <em> Human Evolution, 34</em>(1/2), 1-19. 
    <a
      className="access"
      href="https://research.ebsco.com/linkprocessor/plink?id=072db49a-75d2-36ff-b06e-ba00447a41e2"
    >
      Ebsco
    </a>
  </p>
</div>  
  );
};

export default SueBiblio;
